<template>
  <div slot="pageContent">
    <div v-if="store === 1">
      <form-accordion :title="$t('common.security.pem')" :isTitleUpperCase="false" >
        <b-row class="d-flex form-group">
          <!--b-col sm="6" v-if="isRightPod" class="form-group">
            <div>
              <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
              <span class="color-red">* </span>
              <b-form-select v-model="form.pod" :options="podList" style="font-size:small;"></b-form-select>
            </div>
          </b-col-->
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="form.name" isMandatory
              :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <hr  class="mx-auto mb-4" />
      <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
        <app-button
          v-if="form.stateCertificat === 1"
          :text="$t('common.security.update_certificat')"
          icon="fa-light fa-edit"
          variant="secondary"
          custom-class="mb-5"
          @click="updateCertificat">
        </app-button>
        <app-button
          v-else
          :text="$t('common.security.cancel_certificat')"
          icon="fa-light fa-times"
          variant="secondary"
          custom-class="mb-5"
          @click="cancelCertificat">
        </app-button>
        <b-row v-if="certificateText === '' && form.stateCertificat === 0" class="d-flex justify-content-center align-items-center form-group">
          <b-col sm="6" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="certificateText"
              @input="processCertificat"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col sm="6" class="form-group d-flex flex-column" v-if="certificateText === ''" >
            <span>
              <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
              <span class="color-red">* </span>
            </span>
            <input type="file" @change="handleFileUploadCertificat" accept=".pem" />
          </b-col>
        </b-row>
        <b-row v-if="certificateText !== ''" class="d-flex justify-content-center align-items-center form-group">
          <b-col sm="12" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="certificateText"
              @input="processCertificat"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col sm="6" class="form-group d-flex flex-column" v-if="certificateText === ''" >
            <span>
              <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
              <span class="color-red">* </span>
            </span>
            <input type="file" @change="handleFileUploadCertificat" accept=".pem" />
          </b-col>
        </b-row>
        <b-row class="d-flex align-items-center form-group">
          <b-col sm="6" class="form-group">
            <form-read-group-label-input :inputValue="form.startDate"
              :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-read-group-label-input :inputValue="form.endDate"
              :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="d-flex align-items-center form-group">
          <b-col sm="6" class="form-group">
            <form-read-group-label-input :inputValue="form.deliveredBy"
              :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-read-group-label-input :inputValue="form.deliveredTo"
              :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <hr  class="mx-auto mb-4" />
      <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
        <app-button
          v-if="form.statePrivateKey === 1"
          :text="$t('common.security.update_privatekey')"
          icon="fa-light fa-edit"
          variant="secondary"
          custom-class="mb-5"
          @click="updatePrivateKey">
        </app-button>
        <app-button
          v-else
          :text="$t('common.security.cancel_privatekey')"
          icon="fa-light fa-times"
          variant="secondary"
          custom-class="mb-5"
          @click="cancelPrivateKey">
        </app-button>
        <b-row class="d-flex justify-content-center align-items-center form-group">
          <b-col v-if="privateKeyText === '' && form.statePrivateKey === 0" sm="6" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="privateKeyText"
              @input="processPrivateKey"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col v-if="privateKeyText !== '' && form.statePrivateKey === 0" sm="12" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="privateKeyText"
              @input="processPrivateKey"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col sm="6" class="form-group d-flex flex-column" v-if="privateKeyText === '' && form.statePrivateKey === 0" >
            <span>
              <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
              <span class="color-red">* </span>
            </span>
            <input type="file" @change="handleFileUploadPrivateKey" accept=".key" />
          </b-col>
        </b-row>
        <b-row class="d-flex justify-content-center align-items-center form-group">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="form.password"
              :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group"></b-col>
        </b-row>
      </form-accordion>
    </div>
  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import forge from 'node-forge'
import CertificatesList from "@/pages/security/CertificatesList.vue"
import _ from "lodash"
import {loadPage} from "@/helpers/routing"

export default {
  name: 'KeystoreFormPEM',
  computed: {
    CertificatesList() {
      return CertificatesList
    }
  },
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    AppButton,
  },
  props: ['store', 'keystore'],
  data () {
    return {
      form: {
        state: 0,
        statePrivateKey: 0,
        stateCertificat: 0,
        privateKey: '',
        certificate: '',
        startDate: '',
        endDate: '',
        deliveredBy: '',
        deliveredTo: '',
        name: '',
        nameDisplay: '',
        pod: '',
        password:'',
        id: '',
      },
      oldDeliveredBy: '',
      oldDeliveredTo: '',
      oldEndDate: '',
      oldStartDate: '',
      text: '',
      certificateText: '',
      privateKeyText: '',
      name: '',
      caList: [],
      caListPopUp: [],
      podList: [],
      canSaveTrustStore: false,
      certificatList: []
    }
  },
  watch: {
    certificatList: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
    form: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
  },
  created () {
    this.form.id = this.keystore.id
    this.form.name = this.keystore.name
    this.form.endDate = this.keystore.endDate
    this.oldEndDate = this.keystore.endDate
    this.form.startDate = this.keystore.startDate
    this.oldStartDate = this.keystore.startDate
    this.form.deliveredBy = this.keystore.deliveredBy
    this.oldDeliveredBy = this.keystore.deliveredBy
    this.form.deliveredTo = this.keystore.deliveredTo
    this.oldDeliveredTo = this.keystore.deliveredTo
    //this.form.pod = this.keystore.pod
    this.form.privatekeyId = this.keystore.privatekey
    this.form.statePrivateKey = 1
    this.form.certificatId = this.keystore.certificat
    this.form.password = this.keystore.password
    this.form.stateCertificat = 1
    /*this.$engine.firstOn().routing.pod.fetch()
        .then(resp => {
          if (resp.data.Pods.length != 0){
            this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ""})
            resp.data.Pods.forEach(element => {
              this.podList.push({text: element.name, value: element.name})
            })
          }

        })*/
  },
  methods: {
    /*isRightPod(){
      return this.$engine.firstOn().rights.rightIs('pod_consult', true)
    },*/
    isRightKeystore () {
      return this.$engine.firstOn().rights.rightIs('keystore_add', true)
    },
    isRightPrivateKey () {
      return this.$engine.firstOn().rights.rightIs('privatekey_add', true)
    },
    checkFormTrustStore () {
      let flag = true
      this.certificatList.forEach(element =>{
        if (element.startDate != '' && element.endDate != '' && element.certificate != '' && element.nameDisplay != '' && element.name != ''/* && this.form.pod != ''*/){

        } else {
          flag = false
        }
      })
      if (flag) {
        this.canSaveTrustStore = true
      } else {
        this.canSaveTrustStore = false
      }
    },
    close () {
      this.showModalElement = false
    },
    updatePrivateKey () {
      this.form.statePrivateKey = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelPrivateKey () {
      this.form.statePrivateKey = 1
      this.privateKeyText = ''
      this.form.startDate = this.oldStartDate
      this.form.endDate = this.oldEndDate
      this.form = _.cloneDeep(this.form)
    },
    updateCertificat () {
      this.form.startDate = ''
      this.form.endDate = ''
      this.form.deliveredBy = ''
      this.form.deliveredTo = ''
      this.form.stateCertificat = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelCertificat () {
      this.form.stateCertificat = 1
      this.certificateText = ''
      this.form.startDate = this.oldStartDate
      this.form.endDate = this.oldEndDate
      this.form.deliveredBy = this.oldDeliveredBy
      this.form.deliveredTo = this.oldDeliveredTo
      this.form = _.cloneDeep(this.form)
    },
    processCertificat () {
      try {
        // Traiter le certificat PEM collé dans le textarea
        const certificate = forge.pki.certificateFromPem(this.certificateText)

        // Extraire les informations du certificat
        // const subjectAttributes = certificate.subject.attributes
        // const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName')
        // this.form.name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé'

        this.form.startDate = certificate.validity.notBefore.toLocaleString().toString();
        this.form.endDate = certificate.validity.notAfter.toLocaleString().toString();


        certificate.issuer.attributes.forEach(element => {
          if (element.name == 'commonName'){
            this.form.deliveredBy = element.value
          }
        })
        certificate.subject.attributes.forEach(element => {
          if (element.name == 'commonName'){
            this.form.deliveredTo = element.value
          }
        })

        // Reconversion du certificat en format PEM (pour l'affichage)
        this.form.certificate = forge.pki.certificateToPem(certificate);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = '';

      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error');
        this.form.certificate = '';
        this.form.startDate = '';
        this.form.endDate = '';
        this.form.deliveredBy = '';
        this.form.deliveredTo = '';
      }
    },
    processPrivateKey() {
      try {
        // Traiter le certificat PEM collé dans le textarea
        let privateKey = forge.pki.privateKeyFromPem(this.privateKeyText);

        // Convertir l'objet clé privée en format PEM pour l'afficher
        this.form.privateKey = forge.pki.privateKeyToPem(privateKey);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = ''
      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error')
        this.form.certificate = ''
        this.privateKeyText = ''
      }
    },
    handleFileUploadPrivateKey(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const keyContent = e.target.result

        try {
          const privateKey = forge.pki.privateKeyFromPem(keyContent)
          this.form.privateKey = forge.pki.privateKeyToPem(privateKey)
          this.privateKeyText = forge.pki.privateKeyToPem(privateKey)

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
        }
      };

      reader.readAsText(file)
    },
    handleFileUploadCertificat(event, index = null) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const pemContent = e.target.result;

        try {
          const certificate = forge.pki.certificateFromPem(pemContent);
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          this.certificateText = forge.pki.certificateToPem(certificate)


          const startDate = certificate.validity.notBefore.toLocaleString().toString();
          const endDate = certificate.validity.notAfter.toLocaleString().toString();

          const subjectAttributes = certificate.subject.attributes;
          const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName');
          const name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé';

          certificate.issuer.attributes.forEach(element => {
            if (element.name == 'commonName'){
              this.form.deliveredBy = element.value
            }
          })
          certificate.subject.attributes.forEach(element => {
            if (element.name == 'commonName'){
              this.form.deliveredTo = element.value
            }
          })

          if (index == null){
            this.form.certificate = pemFormattedCert
            this.form.startDate = startDate
            this.form.endDate = endDate
            this.form.nameDisplay = name
          }else{
            this.certificatList[index].certificate = pemFormattedCert
            this.certificatList[index].startDate = startDate
            this.certificatList[index].endDate = endDate
            this.certificatList[index].nameDisplay = name
          }

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err);
        }
      };

      reader.readAsText(file);
    },
    isCertificateAuthority(cert) {
      const basicConstraints = cert.getExtension('basicConstraints');
      return basicConstraints && basicConstraints.cA;
    },
    updateKeystore(){
      let that = this
      /* if (this.form.password == '') {
        this.$f7.alert(that.$i18n.t('common.security.missing_keystore_password'), 'Error')
      } */
      /*else if (this.isRightPod) {
        if (this.form.pod == ''){
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_pod'), 'Error')
        }
      }
      else */if (this.form.name == '') {
        this.$f7.alert(that.$i18n.t('common.security.missing_keystore_name'), 'Error')
      }
      else if (this.form.privateKey == '' && this.form.statePrivateKey == 0) {
        this.$f7.alert(that.$i18n.t('common.security.missing_keystore_private_key'), 'Error')
      }
      else if (this.form.certificate == '' && this.form.stateCertificat == 0) {
        this.$f7.alert(that.$i18n.t('common.security.missing_keystore_certificate'), 'Error')
      }
      else if (this.form.startDate == '') {
        this.$f7.alert(that.$i18n.t('common.security.missing_keystore_start_date'), 'Error')
      }
      else if (this.form.endDate == '') {
        this.$f7.alert(that.$i18n.t('common.security.missing_keystore_end_date'), 'Error')
      }
      if (this.form.password != '' /*|| this.form.pod != ''*/ || this.form.name != ''){
        let form = {
          name: this.form.name,
          password: this.form.password,
          passwordVerif: this.form.password,
          idPod: this.form.pod,
          type: 'SSL',
        }
        if (this.form.statePrivateKey == 0){
          form.privateKey = this.form.privateKey
        }
        else{
          form.privateKey = ''
        }
        form.id = this.form.privatekeyId
        let privateKeyId = ''
        let CertificateId = ''

        let that = this

        if (this.formHasError()) {
          return
        }

        this.$engine.firstOn().security.private_keys.edit(form)
        .then(resp => {
          privateKeyId = resp.data.idPrivateKey

          form = {
            name: this.form.name,
            startDate: this.form.startDate,
            endDate: this.form.endDate,
            deliveredBy: this.form.deliveredBy,
            deliveredTo: this.form.deliveredTo,
            commonName: this.form.name,
            type: 'SSL',
          }
          /*if (this.isRightPod){
            form.idPod = this.form.pod
          }*/
          if (this.form.stateCertificat == 0) {
            form.certificate = this.form.certificate
          } else {
            form.certificate = ''
          }

          form.id = this.form.certificatId
          let that = this

          if (this.formHasError()) {
            return
          }

          this.$engine.firstOn().security.certificates.edit(form)
          .then(resp => {
            CertificateId = resp.data.idCertificat

            form = {
              privateKeyId: this.form.privatekeyId,
              certificatId: this.form.certificatId,
              name: this.form.name,
              id: this.form.id
            }

            this.$engine.firstOn().security.keystore.edit(form)
            .then(resp => {
              that.$f7.alert(that.$i18n.t('common.security.updated_keystore'), that.$i18n.t('common.security.update_keystore_2'))
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })

            loadPage(that, {url: '/security/1'})
          })
          .catch(e => {
            errorMessageAlert(e, that)
            that.okMessageBox(that.$t('common.security.cert_addition_error'))
          })

        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(this.$t('common.security.priv_key_addition_error'))
        })
      }

    },
    formHasError () {
      // let that = this
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.name === undefined || this.name === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_name'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
